import React, { useCallback, useState } from 'react';
import EditorList from './lib/rc-editor-list/src/index';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import { parseStyleStringToReactStyle } from './utils';
import { useTeaAttrsContext } from '@saucerjs/editor';
import { useCurrentTeaId } from '@saucerjs/core';
/**
 * 样式编辑器
 */
export var CSSEditor = React.memo(function () {
    var _a;
    var _b = useState(null), dom = _b[0], setDom = _b[1];
    var _c = useTeaAttrsContext(), currentTeaAttrs = _c.currentTeaAttrs, setCurrentTeaAttrs = _c.setCurrentTeaAttrs;
    var currentTeaId = useCurrentTeaId();
    var styleAttr = (_a = currentTeaAttrs['style']) !== null && _a !== void 0 ? _a : {};
    var handleChange = useCallback(function (state) {
        var cssString = _get(state, ['cssValue', '', 'css', 'default']);
        var styleObj = parseStyleStringToReactStyle(cssString);
        setCurrentTeaAttrs({
            style: styleObj,
        });
    }, [setCurrentTeaAttrs]);
    var handleRef = function (ref) {
        if (_isNil(ref)) {
            return;
        }
        for (var attr in styleAttr) {
            var val = styleAttr[attr];
            ref.style.setProperty(attr, val);
        }
        setDom(ref);
    };
    return (React.createElement("div", { key: currentTeaId },
        React.createElement("div", { style: { display: 'none' } },
            React.createElement("div", { ref: handleRef })),
        dom && (React.createElement(EditorList, { editorElem: dom, onChange: handleChange, useClassName: false, cssToDom: false }))));
});
CSSEditor.displayName = 'CSSEditor';
